module.exports = __webpack_public_path__ + "img/symbol_6.5e0eb46e.png";